export default "__VITE_ASSET__BOYzD$a___"